import { useNavigate } from "@/router";
import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const App = () => {
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if(location.pathname === "/") navigate("/dashboard")
  }, [])

  return (
    <div className="dark:bg-boxdark-2 dark:text-bodydark">
      <div className="flex h-screen overflow-hidden">
        {/* Component */}
        <Outlet />

        <ToastContainer
          autoClose={1500}
          position="top-right"
          className="text-sm"
          theme="colored"
        />
      </div>
    </div>
  );
};

export default App;
